import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, Router, withInMemoryScrolling } from '@angular/router';
import axios from 'axios';
import { environment } from '../environments/environment';
import { attachApiAuthInterceptors, AuthService, provideAuth } from './core/auth';
import { attachAttestationExpiryInterceptor } from './core/api/attach-attestation-expiry';
import { AXIOS_INSTANCE } from './core/api/api-client.tokens';
import { ShipmentFlowStateService } from './core/services/shipment-flow-state.service';
import { provideI18n } from './core/i18n';
import { routes } from './app.routes';
import {
  CdnWebChatConfiguratorLoader,
  WebChatConfiguratorLoader,
} from './layout/chatbot/web-chat-configurator.loader';
import { provideAnalytics } from './core/integrations/analytics';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideI18n(),
    ...provideAnalytics(),
    ...provideAuth(),
    { provide: WebChatConfiguratorLoader, useExisting: CdnWebChatConfiguratorLoader },
    {
      provide: AXIOS_INSTANCE,
      useFactory: (auth: AuthService, flowState: ShipmentFlowStateService, router: Router) => {
        const instance = axios.create({
          baseURL: environment.apiBaseUrl,
          headers: {
            Accept: 'application/json',
          },
        });

        attachApiAuthInterceptors(instance, {
          getAccessToken: () => auth.getAccessToken(),
          tryRecoverSessionSilently: () => auth.tryRecoverSessionSilently(),
          onUnauthorized: (status) => auth.handleUnauthorized(status),
        });

        // After auth so this interceptor sees raw API errors first (LIFO response chain).
        attachAttestationExpiryInterceptor(instance, {
          onAttestationExpired: () => {
            flowState.clearAttestations();
            void router.navigateByUrl('/');
          },
        });

        return instance;
      },
      deps: [AuthService, ShipmentFlowStateService, Router],
    },
  ],
};
